import React from 'react';
import { IconProps } from '../types/types';

const HON: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" role="img" {...props}><path fill="#DE1E34" d="M0 0h18v18H0z"/><path d="M10 8H7.954V4H4v10h3.954V9H10v5h4V4h-4v4z" fill="#fff"/></svg>
);

export default HON;